import { AfterViewInit, Component, EventEmitter, OnChanges, Output, SimpleChanges, ViewChild, input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { faFire } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-view-assignments',
    templateUrl: './view-assignments.component.html',
    styleUrl: './view-assignments.component.scss',
    standalone: false
})
export class ViewAssignmentsComponent implements AfterViewInit, OnChanges {
  faFire = faFire;

  assignmentList = input.required<any>();
  assignments = new MatTableDataSource<any>();
  displayedColumns!: string[];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort: MatSort = new MatSort;
    @Output() loaded = new EventEmitter();

  constructor() {
    this.displayedColumns = [
      'baer_name',
      'report_id',
      'forest_name',
      'skills',
      'dates'
    ]
  }

  ngOnChanges(changes: SimpleChanges) {
    this.assignments.data = this.assignmentList();
    this.setTooltip(this.assignments.data)
  }

  ngAfterViewInit() {
    this.assignments.sort = this.sort;
    this.assignments.paginator = this.paginator;

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    this.loaded.emit(1);
  }

  setTooltip(assignments: any) {
    assignments.forEach((assignment: any) => {
      let tooltip = '';
      for (let i = 1; assignment.skills.length - 1 >= i; i++) {
        tooltip += assignment.skills[i].skill.text + '\n'
      }
      assignment.tooltip = tooltip;
    });
  }
}
